import { InjectionToken, type Signal } from '@angular/core';
import type { HomeSummaryLink } from '@quipex/feature/quippy-conversation';

export const APP_QUIPPY_HOME_ACTIONS = new InjectionToken<
    Signal<readonly HomeSummaryLink[]>
>('APP_QUIPPY_HOME_ACTIONS');
